import { CellTable } from "@/atoms"

import type { TFunction } from "@/hooks/useTranslation"
import type { getReportDefinition } from "@/pages/ReportsPage/applications/useReports.selector"

export const FrequencyCell = (props: { t: TFunction }) =>
  function FrequencyCellComponent(
    _: unknown,
    record: ReturnType<typeof getReportDefinition>["data"][number]
  ) {
    return CellTable(
      props.t([`general.frequency.${record?.frequency?.[0]}`, "-"])
    )
  }
